/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'text': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1 3.56A2.56 2.56 0 0 1 3.56 1h40.88A2.56 2.56 0 0 1 47 3.56v7.66a2.56 2.56 0 0 1-5.11 0v-5.1H6.1v5.1a2.56 2.56 0 1 1-5.11 0V3.56zm12.78 40.88a2.56 2.56 0 0 1 2.55-2.55h15.34a2.56 2.56 0 0 1 0 5.11H16.33a2.56 2.56 0 0 1-2.55-2.56z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M24 1a2.56 2.56 0 0 1 2.56 2.56v40.88a2.56 2.56 0 1 1-5.12 0V3.56A2.56 2.56 0 0 1 24 1z"/>'
  }
})
